// obtener Data libro Contable
import $http from "../../axios";
import {Notification} from "element-ui";
import {setLoading} from "./mutations";

export async function fetchReportData({commit, state}) {
    state.loading.module = true;
    await $http.get('/api/documento/reconciliacion-inventario', {params: state.params})
        .then((response) => {
            commit('setReportData', response.data.data);
            state.loading.module = false;
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: 'Error',
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })

}
//recontabilizar documento
export async function accountingDoc({commit, state, dispatch}, document_id){
    state.loading.module = true
    await $http.get(`/api/documento/contabilizar/${document_id}`)
        .then(response => {
            state.loading.module = false;
            dispatch('fetchReportData')
            Notification.success({
                title: "Success!",
                message: 'Documento Recontabilizado Correctamente',
                type: "success",
                duration: 4500,
                customClass: "notification-box"
            });
        })
        .catch(error => {
            state.loading.module = false
            Notification.error({
                title: "Error!",
                message: data.message,
                type: "error",
                duration: 4500,
                customClass: "notification-box"
            });
        });
}
export async function getReportByDocumentId({commit, state, dispatch}, document_id) {
    await $http.get(`/api/documento/reconciliacion-inventario/${document_id}`)
        .then(response => {
          /*  commit('validate_search', response.data.data);*/
            state.loading.module = false
            Notification.success({
                title: "Succes!",
                message: 'Recontabilización Finalizada, Datos Actualizados Correctamente',
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        })
        .catch(error => {
            let data = error.response.data
            Notification.error({
                title: "Error!",
                message: data.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/inventory-reconciliation/actions.js